import { render, staticRenderFns } from "./Auditlog.vue?vue&type=template&id=13226d0c"
import script from "./Auditlog.vue?vue&type=script&lang=js"
export * from "./Auditlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports